<template>
  <div class="m-only">
    <div class="share-m" @click="showShare">
      <iconpark-icon name="share-v2" class="text-[24px]"></iconpark-icon>
      <span class="ml-[10px]">分享3D数字人</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
const { $t } = useNuxtApp()

function showShare() {
  copyToClipboard(location.href)
  message.success($t('fu-zhi-cheng-gong'))
}
</script>
<style lang="scss" scoped>
.share-m {
  height: vw(56);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
  background: linear-gradient(262.93deg, #05d4ff -17.55%, #ef17fd 158.74%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-0);
  position: fixed;
  bottom: 0;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  z-index: 100;
}
</style>
